<template>
  <div>
    <el-input
      :id="id"
      ref="mac"
      v-model="ele"
      size="small"
      maxlength="17"
      :disabled="disabled"
      :placeholder="placeholder"
      @keyup.native="change()"
      @mouseup.native="change()"
      @input="change()"
    />
  </div>
</template>
<script>
// import { logWithPrefix } from '@/plugins/logging'
// const log = logWithPrefix('[components/elements/macAddress.vue]')
export default {
  props: {
    id: {
      type: String,
      default: "mac",
    },
    config: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    allowColon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ele: "",
    };
  },
  watch: {
    config: {
      handler() {
        this.ele = this.config;
        this.change();
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      const val = this.ele.toUpperCase();
      this.ele = val;
      this.$emit("update:config", this.ele);
    },
  },
};
</script>
